import http from '@/services/rest/rest.service';
import { ISearchBody, ISortBody } from '@/entities/search-body.interface';
import { IAccount } from '@/entities/accounts/account.interface';

export default {
    forgot(body: {
        username: string;
        email: string;
    }): Promise<string> {
        return http.post('forgot', body);
    }
};
